import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { ResetPassword } from './pages/ResetPassword.jsx'
import { initSentry } from './services/sentry.js'

// Initialize Sentry for error tracking
const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN
if (SENTRY_DSN) {
  initSentry(SENTRY_DSN)
}

// Simple routing for auth pages
function Root() {
  const path = window.location.pathname

  // Handle auth routes
  if (path === '/auth/reset-password') {
    return <ResetPassword />
  }

  // Default to main app
  return <App />
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Root />
  </StrictMode>,
)
